import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbCarouselModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PageComponentModule } from '../../../cms-structure';
import { provideDefaultConfig } from '../../../core/config';
import { I18nModule } from '../../../core/i18n';
import { PipesModule, ProgressbarModule } from '../../../shared';
import { TimedBannerCollectionComponent } from './timed-banner-collection.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    PageComponentModule,
    ProgressbarModule,
    NzIconModule,
    NgbCarouselModule,
    NgbTooltipModule,
    PipesModule,
  ],
  declarations: [TimedBannerCollectionComponent],
  exports: [TimedBannerCollectionComponent],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        TimedBannerCollectionComponent: {
          component: TimedBannerCollectionComponent,
        },
      },
    }),
  ],
})
export class TimedBannerCollectionModule {}
